/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateReviewCommand } from '../models/create-review-command';
import { CreateReviewFromInviteCommand } from '../models/create-review-from-invite-command';
import { GetReviewsByUserResult } from '../models/get-reviews-by-user-result';
import { GetReviewsForUserQuery } from '../models/get-reviews-for-user-query';
import { InviteView } from '../models/invite-view';
import { ReviewResultView } from '../models/review-result-view';
import { ReviewView } from '../models/review-view';

@Injectable({
  providedIn: 'root',
})
export class ReviewService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation canReviewListing
   */
  static readonly CanReviewListingPath = '/api/Review/CanReviewListing/{listingId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `canReviewListing()` instead.
   *
   * This method doesn't expect any request body.
   */
  canReviewListing$Response(params: {
    listingId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, ReviewService.CanReviewListingPath, 'get');
    if (params) {
      rb.path('listingId', params.listingId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `canReviewListing$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  canReviewListing(params: {
    listingId: string;
    context?: HttpContext
  }
): Observable<boolean> {

    return this.canReviewListing$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation canReviewUser
   */
  static readonly CanReviewUserPath = '/api/Review/CanReviewUser/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `canReviewUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  canReviewUser$Response(params: {
    userId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, ReviewService.CanReviewUserPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `canReviewUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  canReviewUser(params: {
    userId: string;
    context?: HttpContext
  }
): Observable<boolean> {

    return this.canReviewUser$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation createReview
   */
  static readonly CreateReviewPath = '/api/Review/CreateReview';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createReview()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createReview$Response(params?: {
    context?: HttpContext
    body?: CreateReviewCommand
  }
): Observable<StrictHttpResponse<ReviewView>> {

    const rb = new RequestBuilder(this.rootUrl, ReviewService.CreateReviewPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReviewView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createReview$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createReview(params?: {
    context?: HttpContext
    body?: CreateReviewCommand
  }
): Observable<ReviewView> {

    return this.createReview$Response(params).pipe(
      map((r: StrictHttpResponse<ReviewView>) => r.body as ReviewView)
    );
  }

  /**
   * Path part for operation getByUser
   */
  static readonly GetByUserPath = '/api/Review/GetByUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByUser$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<GetReviewsByUserResult>> {

    const rb = new RequestBuilder(this.rootUrl, ReviewService.GetByUserPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetReviewsByUserResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getByUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByUser(params?: {
    context?: HttpContext
  }
): Observable<GetReviewsByUserResult> {

    return this.getByUser$Response(params).pipe(
      map((r: StrictHttpResponse<GetReviewsByUserResult>) => r.body as GetReviewsByUserResult)
    );
  }

  /**
   * Path part for operation getForUser
   */
  static readonly GetForUserPath = '/api/Review/GetForUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getForUser()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getForUser$Response(params?: {
    context?: HttpContext
    body?: GetReviewsForUserQuery
  }
): Observable<StrictHttpResponse<ReviewResultView>> {

    const rb = new RequestBuilder(this.rootUrl, ReviewService.GetForUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReviewResultView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getForUser$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getForUser(params?: {
    context?: HttpContext
    body?: GetReviewsForUserQuery
  }
): Observable<ReviewResultView> {

    return this.getForUser$Response(params).pipe(
      map((r: StrictHttpResponse<ReviewResultView>) => r.body as ReviewResultView)
    );
  }

  /**
   * Path part for operation getForListing
   */
  static readonly GetForListingPath = '/api/Review/GetForListing/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getForListing()` instead.
   *
   * This method doesn't expect any request body.
   */
  getForListing$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ReviewResultView>> {

    const rb = new RequestBuilder(this.rootUrl, ReviewService.GetForListingPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReviewResultView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getForListing$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getForListing(params: {
    id: string;
    context?: HttpContext
  }
): Observable<ReviewResultView> {

    return this.getForListing$Response(params).pipe(
      map((r: StrictHttpResponse<ReviewResultView>) => r.body as ReviewResultView)
    );
  }

  /**
   * Path part for operation createReviewFromInvite
   */
  static readonly CreateReviewFromInvitePath = '/api/Review/CreateReviewFromInvite';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createReviewFromInvite()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createReviewFromInvite$Response(params?: {
    context?: HttpContext
    body?: CreateReviewFromInviteCommand
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ReviewService.CreateReviewFromInvitePath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createReviewFromInvite$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createReviewFromInvite(params?: {
    context?: HttpContext
    body?: CreateReviewFromInviteCommand
  }
): Observable<void> {

    return this.createReviewFromInvite$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getInvite
   */
  static readonly GetInvitePath = '/api/Review/GetInvite{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvite()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvite$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<InviteView>> {

    const rb = new RequestBuilder(this.rootUrl, ReviewService.GetInvitePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InviteView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInvite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvite(params: {
    id: string;
    context?: HttpContext
  }
): Observable<InviteView> {

    return this.getInvite$Response(params).pipe(
      map((r: StrictHttpResponse<InviteView>) => r.body as InviteView)
    );
  }

  /**
   * Path part for operation refuseInvite
   */
  static readonly RefuseInvitePath = '/api/Review/RefuseInvite/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refuseInvite()` instead.
   *
   * This method doesn't expect any request body.
   */
  refuseInvite$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<InviteView>> {

    const rb = new RequestBuilder(this.rootUrl, ReviewService.RefuseInvitePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InviteView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `refuseInvite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  refuseInvite(params: {
    id: string;
    context?: HttpContext
  }
): Observable<InviteView> {

    return this.refuseInvite$Response(params).pipe(
      map((r: StrictHttpResponse<InviteView>) => r.body as InviteView)
    );
  }

}
